import { Zap, Coins, Flame } from "lucide-react";
import { fmtARS } from "../lib/utils-app";
import { HangingSpider } from "./Halloween";

const ROBUX_IMG =
  "https://images.unsplash.com/photo-1614624532983-4ce03382d63d?crop=entropy&cs=srgb&fm=jpg&q=80&w=400";

export default function RobuxCard({ product, selected, onSelect, theme }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(product)}
      data-testid={`package-card-${product.id}`}
      className="relative w-full min-w-0 rounded-xl p-3 sm:p-5 text-left overflow-hidden"
      style={{
        background: "#0d0d0d",
        border: `1px solid ${selected ? theme.primary : `${theme.primary}40`}`,
        boxShadow: selected ? `0 0 0 2px ${theme.primary}55, 0 12px 40px ${theme.primary}55` : "none",
        transition: "transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-3px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
    >
      <HangingSpider length={product.robux % 3 ? 30 : 42} side="left" />
      {/* Decorative coin image */}
      <div
        className="absolute right-0 top-0 w-24 h-24 rounded-full opacity-20 pointer-events-none"
        style={{ backgroundImage: `url(${ROBUX_IMG})`, backgroundSize: "cover", backgroundPosition: "center" }}
        aria-hidden
      />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: `linear-gradient(135deg, transparent 60%, ${theme.primary}22)` }}
        aria-hidden
      />

      {product.bonus && (
        <span
          className="absolute -top-2 left-4 text-[10px] px-2 py-0.5 rounded-md tracking-wider z-10 font-bold text-black"
          style={{ background: `linear-gradient(135deg, ${theme.primary}, #a3ff8a)` }}
        >
          {product.bonus}
        </span>
      )}
      {product.popular && (
        <span className="absolute top-3 right-3 flex items-center gap-1 text-[10px] tracking-widest z-10" style={{ color: theme.primary }}>
          <Flame className="w-3 h-3" /> POPULAR
        </span>
      )}

      <div className="relative flex items-center gap-2 sm:gap-3 mb-3">
        <div
          className="w-9 h-9 sm:w-11 sm:h-11 shrink-0 rounded-md grid place-items-center"
          style={{ background: "#0a1a0a", border: `1px solid ${theme.primary}88`, filter: `drop-shadow(0 0 8px ${theme.primary}aa)` }}
        >
          <Coins className="w-6 h-6" style={{ color: theme.primary }} strokeWidth={2} />
        </div>
        <div>
          <div className="font-display text-3xl sm:text-4xl leading-none tracking-wider text-white">
            {product.robux.toLocaleString("es-AR")}
          </div>
          <div className="text-[10px] text-neutral-400 uppercase tracking-widest">Robux</div>
        </div>
      </div>

      <div className="relative flex flex-wrap items-end justify-between gap-2 pt-3 border-t border-white/5">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-neutral-500">Precio</div>
          <div className="text-base sm:text-lg font-bold text-white">{fmtARS(product.unit_price_ars)}</div>
        </div>
        <div
          className="text-[10px] sm:text-xs px-2 py-1 rounded-md flex items-center gap-1"
          style={{
            background: selected ? theme.primary : "rgba(255,255,255,0.05)",
            color: selected ? "#000" : "#d4d4d4",
          }}
        >
          <Zap className="w-3 h-3" /> {selected ? "OK" : "ELEGIR"}
        </div>
      </div>
    </button>
  );
}
